import React from 'react';

export default function PageHeader({ title, icon, subtitle, actions, breadcrumb }) {
  return (
    <div className="page-header">
      <div>
        <h4 className="page-title">
          {icon && <i className={`bi ${icon}`}></i>}
          {title}
        </h4>
        {subtitle && <p className="text-muted mb-0" style={{ fontSize: 13 }}>{subtitle}</p>}
        {breadcrumb && (
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              {breadcrumb.map((b, i) => (
                <li key={i} className={`breadcrumb-item ${i === breadcrumb.length - 1 ? 'active' : ''}`}>
                  {b}
                </li>
              ))}
            </ol>
          </nav>
        )}
      </div>
      {actions && <div className="d-flex gap-2 align-items-center">{actions}</div>}
    </div>
  );
}
